import {Component, OnInit} from '@angular/core';
import {environment} from '../../../../../../environments/environment';
import {HttpService} from '../../../../../shared/_services/http.service';
import {ValidationService} from '../../../../../shared/_services/validation.service';
import {AuditDashboardService} from '../../../../../shared/_services/audit-dashboard.service';
import {UtilService} from '../../../../../shared/_services/util.service';
import {IMyDateModel, IMyDpOptions} from 'mydatepicker';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-reports',
  templateUrl: './audit-dashboard.component.html',
  styleUrls: ['./audit-dashboard.component.scss']
})
export class AuditDashboardComponent implements OnInit {

  report: any = FormGroup;
  report1: any = FormGroup;
  report2: any = FormGroup;
  report3: any = FormGroup;
  report4: any = FormGroup;
  isDimension1: boolean = false;
  isDimension2: boolean = false;
  isDimension3: boolean = false;
  isDimension4: boolean = false;
  defaultPointsForDimension1: number = 40;
  defaultPointsForDimension2: number = 150;
  defaultPointsForDimension3: number = 150;
  defaultPointsForDimension4: number = 150;

  myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    editableDateField: false,
    inline: false,
    openSelectorOnInputClick: true
  };

  dimensions = [
    {id: '1', name: 'Transactions above X amount of coins'},
    {id: '2', name: 'List of agents who have approved transactions within a range of X days for a sum of X coins'},
    {id: '3', name: 'Members who obtain transactions within a range of X days for a summed amount of X coins'},
    {id: '4', name: 'List of members who exceed their wallet by X amount of coins'}
  ];

  documentUrl: String = null;
  errorDetails: String = null;
  serverEndpoint = this.reportService.getReportForDimension1;

  constructor(
    private fb: FormBuilder,
    private http: HttpService,
    private validationService: ValidationService,
    private utilService: UtilService,
    private reportService: AuditDashboardService,
  ) {

  }

  initForm() {

    this.report = this.fb.group({
      dimension: ['', Validators.required],
      points: ['', Validators.compose([Validators.required, Validators.max(9999999999), Validators.pattern('^[-+]?[0-9]+$')])],
      //transactions: ['', Validators.compose([Validators.required, Validators.max(9999999999), Validators.pattern('^[-+]?[0-9]+$')])],
      dateTo: ['', Validators.compose([Validators.required, this.validationService.simpleCheckDateRange.bind(this)])],
      dateFrom: ['', Validators.compose([Validators.required, this.validationService.simpleCheckDateRange.bind(this)])]
    });
    this.report1 = this.fb.group({
      points: [this.defaultPointsForDimension1, Validators.compose([Validators.required, Validators.max(9999999999), Validators.pattern('^[-+]?[0-9]+$')])],
      dateTo: ['', Validators.compose([Validators.required, this.validationService.simpleCheckDateRange.bind(this)])],
      dateFrom: ['', Validators.compose([Validators.required, this.validationService.simpleCheckDateRange.bind(this)])]
    });
    this.report2 = this.fb.group({
      points: [this.defaultPointsForDimension2, Validators.compose([Validators.required, Validators.max(9999999999), Validators.pattern('^[-+]?[0-9]+$')])],
      //transactions: ['', Validators.compose([Validators.required, Validators.max(9999999999), Validators.pattern('^[-+]?[0-9]+$')])],
      dateTo: ['', Validators.compose([Validators.required, this.validationService.simpleCheckDateRange.bind(this)])],
      dateFrom: ['', Validators.compose([Validators.required, this.validationService.simpleCheckDateRange.bind(this)])]
    });
    this.report3 = this.fb.group({
      points: [this.defaultPointsForDimension3, Validators.compose([Validators.required, Validators.max(9999999999), Validators.pattern('^[-+]?[0-9]+$')])],
      //transactions: ['', Validators.compose([Validators.required, Validators.max(9999999999), Validators.pattern('^[-+]?[0-9]+$')])],
      dateTo: ['', Validators.compose([Validators.required, this.validationService.simpleCheckDateRange.bind(this)])],
      dateFrom: ['', Validators.compose([Validators.required, this.validationService.simpleCheckDateRange.bind(this)])]
    });
    this.report4 = this.fb.group({
      points: [this.defaultPointsForDimension4, Validators.compose([Validators.required, Validators.max(9999999999), Validators.pattern('^[-+]?[0-9]+$')])]
    });
  }

  ngOnInit() {
    this.initForm();
  }

  selectDimension(dimension) {
    if (dimension == 1) {
      this.isDimension1 = true;
      this.isDimension2 = false;
      this.isDimension3 = false;
      this.isDimension4 = false;
    } else if (dimension == 2) {
      this.isDimension1 = false;
      this.isDimension2 = true;
      this.isDimension3 = false;
      this.isDimension4 = false;
    } else if (dimension == 3) {
      this.isDimension1 = false;
      this.isDimension2 = false;
      this.isDimension3 = true;
      this.isDimension4 = false;
    } else if( dimension == 4) {
      this.isDimension1 = false;
      this.isDimension2 = false;
      this.isDimension3 = false;
      this.isDimension4 = true;
    } else {
      this.isDimension1 = false;
      this.isDimension2 = false;
      this.isDimension3 = false;
      this.isDimension4 = false;
    }
      
  }

  onDateChanged(event: IMyDateModel, type) {
    this.report1.get(type).setValue(event.formatted);
    this.report1.get(type).markAsDirty();
    this.report1.get(type).markAsTouched();
    if (type === 'dateFrom' && !this.report1.get('dateTo').value) {
      const dateTo = new Date(event.formatted);
      dateTo.setMonth(dateTo.getMonth() + 2);
      this.report1.get('dateTo').setValue(
        {
          date: {
            year: dateTo.getFullYear(),
            month: dateTo.getMonth(),
            day: dateTo.getDay(),
          }
        }
      );
      this.report1.get('dateTo').setValue(
        {
          formatted: `${dateTo.getMonth()}/${dateTo.getDate()}/${dateTo.getFullYear()}`
        }
      );
    }


    this.report2.get(type).setValue(event.formatted);
    this.report2.get(type).markAsDirty();
    this.report2.get(type).markAsTouched();
    if (type === 'dateFrom' && !this.report2.get('dateTo').value) {
      const dateTo = new Date(event.formatted);
      dateTo.setMonth(dateTo.getMonth() + 2);
      this.report2.get('dateTo').setValue(
        {
          date: {
            year: dateTo.getFullYear(),
            month: dateTo.getMonth(),
            day: dateTo.getDay(),
          }
        }
      );
      this.report2.get('dateTo').setValue(
        {
          formatted: `${dateTo.getMonth()}/${dateTo.getDate()}/${dateTo.getFullYear()}`
        }
      );
    }

    this.report3.get(type).setValue(event.formatted);
    this.report3.get(type).markAsDirty();
    this.report3.get(type).markAsTouched();
    if (type === 'dateFrom' && !this.report3.get('dateTo').value) {
      const dateTo = new Date(event.formatted);
      dateTo.setMonth(dateTo.getMonth() + 2);
      this.report3.get('dateTo').setValue(
        {
          date: {
            year: dateTo.getFullYear(),
            month: dateTo.getMonth(),
            day: dateTo.getDay(),
          }
        }
      );
      this.report3.get('dateTo').setValue(
        {
          formatted: `${dateTo.getMonth()}/${dateTo.getDate()}/${dateTo.getFullYear()}`
        }
      );
    }
  }


  generateReport1() {
    const dateFrom = new Date(this.report1.value.dateFrom.formatted);
    const dateTo = new Date(this.report1.value.dateTo.formatted);
    var start_date = dateFrom.getFullYear() + '-' + (dateFrom.getMonth() + 1).toString().padStart(2,'0') + '-' + dateFrom.getDate().toString().padStart(2,'0');
    var end_date = dateTo.getFullYear() + '-' + (dateTo.getMonth() + 1).toString().padStart(2,'0') + '-' + dateTo.getDate().toString().padStart(2,'0');
    let data = {
      coins_limit: this.report1.value.points,
      starting_date: start_date,
      ending_date: end_date
    };
    this.serverEndpoint = this.reportService.getReportForDimension1;
    this.serverEndpoint(data)
      .subscribe(
        res => {
          if (res.message === 'success') {
            this.documentUrl = environment.REPORTS_HOST + res.file_path;
            this.errorDetails = '';
          } else {
            this.errorDetails = res.message;
            this.documentUrl = '';
          }
        },
        error => {
          this.errorDetails = error.message;
          this.documentUrl = '';
        }
      );
  }

  generateReport2() {
    const dateFrom = new Date(this.report2.value.dateFrom.formatted);
    const dateTo = new Date(this.report2.value.dateTo.formatted);
    var start_date = dateFrom.getFullYear() + '-' + (dateFrom.getMonth() + 1).toString().padStart(2,'0') + '-' + dateFrom.getDate().toString().padStart(2,'0');
    var end_date = dateTo.getFullYear() + '-' + (dateTo.getMonth() + 1).toString().padStart(2,'0') + '-' + dateTo.getDate().toString().padStart(2,'0');
    let data = {
      coins_limit: this.report2.value.points,
      starting_date: start_date,
      ending_date: end_date
    };
    
    this.serverEndpoint = this.reportService.getReportForDimension2;

    this.serverEndpoint(data)
      .subscribe(
        res => {
          if (res.message === 'success') {
            this.documentUrl = environment.REPORTS_HOST + res.file_path;
            this.errorDetails = '';
          } else {
            this.errorDetails = res.message;
            this.documentUrl = '';
          }
        },
        error => {
          this.errorDetails = error.message;
          this.documentUrl = '';
        }
      );
  }

  generateReport3() {
    const dateFrom = new Date(this.report3.value.dateFrom.formatted);
    const dateTo = new Date(this.report3.value.dateTo.formatted);
    var start_date = dateFrom.getFullYear() + '-' + (dateFrom.getMonth() + 1).toString().padStart(2,'0') + '-' + dateFrom.getDate().toString().padStart(2,'0');
    var end_date = dateTo.getFullYear() + '-' + (dateTo.getMonth() + 1).toString().padStart(2,'0') + '-' + dateTo.getDate().toString().padStart(2,'0');
    let data = {
      coins_limit: this.report3.value.points,
      starting_date: start_date,
      ending_date: end_date
    };
    
    this.serverEndpoint = this.reportService.getReportForDimension3;

    this.serverEndpoint(data)
      .subscribe(
        res => {
          if (res.message === 'success') {
            this.documentUrl = environment.REPORTS_HOST + res.file_path;
            this.errorDetails = '';
          } else {
            this.errorDetails = res.message;
            this.documentUrl = '';
          }
        },
        error => {
          this.errorDetails = error.message;
          this.documentUrl = '';
        }
      );
  }

  generateReport4() {
    let coins_limit = this.report4.value.points
    this.serverEndpoint = this.reportService.getReportForDimension4;

    this.serverEndpoint(coins_limit)
      .subscribe(
        res => {
          if (res.message === 'success') {
            this.documentUrl = environment.REPORTS_HOST + res.file_path;
            this.errorDetails = '';
          } else {
            this.errorDetails = res.message;
            this.documentUrl = '';
          }
        },
        error => {
          this.errorDetails = error.message;
          this.documentUrl = '';
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/reports/audit-dashboard/audit-dashboard.component.ts